import {mfaHeld} from '~/utils/mfa';
import { useAuthService } from "~/composables/useAuthService";
import { setupScreenDestination } from "~/composables/useAccountSetup";

// Holds an account the server marked setupRequired (created without the terms
// and a date of birth: a social sign-in, or an old email link) on
// /details-required, with the legal pages, contact and the email one-click
// pages as exits. A missing name no longer holds here: the sign-up prompt set
// asks for it, through the prompt wall (userFormPrompt.global.js, which runs
// after this one). The decision is a pure function so it can be tested; see
// setupScreenDestination.
export default defineNuxtRouteMiddleware((to) => {
    const { isAuthenticated, user } = useAuthService();
    if (!isAuthenticated.value) return;
    // The two-step wall goes first and alone (utils/mfa.js mfaHeld).
    if (mfaHeld(user.value)) return;

    const destination = setupScreenDestination(to, user.value);
    if (destination) return navigateTo(destination);
});
